import NebulaDashboard from "../NebulaDashboard";
import { useAuth } from "../lib/AuthContext";
import LandingPage from "./LandingPage";

export default function DashboardGate() {
    const { authenticated, initializing, authError } = useAuth();

    if (initializing) {
        return (
            <div className="min-h-screen bg-gray-950 text-gray-400 flex items-center justify-center" data-testid="auth-loading">
                Checking credentials…
            </div>
        );
    }

    if (!authenticated) {
        return (
            <div className="relative" data-testid="auth-required">
                {authError ? (
                    <div className="absolute top-2 left-1/2 -translate-x-1/2 z-20 bg-red-500/20 text-red-200 text-sm px-4 py-2 rounded-full shadow-lg">
                        {authError}
                    </div>
                ) : null}
                <LandingPage />
            </div>
        );
    }

    const adminEnabled = globalThis.__IMPORT_META_ENV__?.VITE_ADMIN_MODE === "true";

    return <NebulaDashboard adminEnabled={adminEnabled} />;
}
